export const environment = {
  production: true
};



// WEBPACK FOOTER //
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/environments/environment.ts